import clsx from 'clsx'
import type { ReactNode } from 'react'

type BadgeVariant = 'brand' | 'success' | 'error' | 'warning' | 'info' | 'gray'
type BadgeSize = 'sm' | 'md'

interface BadgeProps {
  variant?: BadgeVariant
  size?: BadgeSize
  children: ReactNode
  icon?: ReactNode
  dot?: boolean
  className?: string
}

const variantStyles: Record<BadgeVariant, string> = {
  brand:   'bg-brand-50 text-brand-600',
  success: 'bg-success-50 text-success-600',
  error:   'bg-error-50 text-error-600',
  warning: 'bg-warning-50 text-warning-600',
  info:    'bg-info-50 text-info-600',
  gray:    'bg-gray-100 text-gray-600',
}

const dotColors: Record<BadgeVariant, string> = {
  brand:   'bg-brand-500',
  success: 'bg-success-500',
  error:   'bg-error-500',
  warning: 'bg-warning-500',
  info:    'bg-info-500',
  gray:    'bg-gray-500',
}

const sizeStyles: Record<BadgeSize, string> = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-xs',
}

export default function Badge({ variant = 'gray', size = 'sm', children, icon, dot, className }: BadgeProps) {
  return (
    <span className={clsx(
      'inline-flex items-center gap-1.5 rounded-full font-medium',
      variantStyles[variant],
      sizeStyles[size],
      className,
    )}>
      {dot && <span className={clsx('w-1.5 h-1.5 rounded-full', dotColors[variant])} />}
      {icon && <span className="flex-shrink-0">{icon}</span>}
      {children}
    </span>
  )
}
